module.exports = __webpack_public_path__ + "static/media/image-2.3b39e486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-2.jpg
// module id = 344
// module chunks = 0